export default class SocialData {
  constructor(
    facebook_id = null,
    facebook_enabled = null,
    twitter_id = null,
    twitter_enabled = null,
    instagram_id = null,
    instagram_enabled = null
  ) {
    this.facebook_id = facebook_id;
    this.facebook_enabled = facebook_enabled;
    this.twitter_id = twitter_id;
    this.twitter_enabled = twitter_enabled;
    this.instagram_id = instagram_id;
    this.instagram_enabled = instagram_enabled;
  }
}